export default __webpack_public_path__ + "static/media/metropolis.eadbd69b.svg";